// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

export default class StacksOps extends React.Component {

    componentDidMount = async () => {
        const q = this.props.match.params.query;
        if (q && q.length > 2)
            this.props.search(q);

        if (this.props.match.params.stackId)
            this.props.live(this.props.match.params.stackId);

        //this.props.clearSelection();
    }

    componentDidUpdate = async (prev) => {
        const q = this.props.match.params.query;
        const p = prev.match.params.query;
        if (q && q.length > 2 && q !== p)
            prev.search(q);

        if (this.props.match.params.stackId !== prev.match.params.stackId) {
            this.props.live(this.props.match.params.stackId);
            //this.props.clearSelection();
        }
    }

    render = () => {
        return (<></>);
    }

}